import uiRouterModule from "@uirouter/angularjs";

import StringUtils from "tbClient/utility/StringUtils";
import TrackingEventSearchViewModuleConstants from "tbClient/views/tracking-event-search/Constants";

function AddTrackingEventSearchSetTitleHook($transitions, $log) {
    const setTrackingEventSearchPageTitle = (transition) => {
        const documentSvc = transition.injector().get("$document");

        const searchStateParams = transition.params();
        const searchQuery = searchStateParams.searchQuery;

        let pageTitleParts = [
            TrackingEventSearchViewModuleConstants.pageTitlePrefix
        ];

        if (!StringUtils.IsNullOrWhitespace(searchQuery)) {
            pageTitleParts.push(": ", searchQuery);
        }

        const pageTitle = pageTitleParts.join("");

        $log.debug(`Tracking Event Search Set Title Hook: Setting Page Title To '${pageTitle}'`);
        documentSvc.attr("title", pageTitle);
    };

    $transitions.onSuccess(
        {to: TrackingEventSearchViewModuleConstants.rootStateName},
        setTrackingEventSearchPageTitle
    );
}

AddTrackingEventSearchSetTitleHook.$inject = ["$transitions", "$log"];
AddTrackingEventSearchSetTitleHook.dependencies = [
    uiRouterModule
];

export default AddTrackingEventSearchSetTitleHook;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-search/SetTrackingEventSearchPageTitleHook.js
// module id = n2Oy
// module chunks = 1